import * as React from 'react';
import { ReactElement } from 'react';
import GroupDetailContainer from '../../containers/groups/detail/GroupDetailContainer';

const GroupDetail = (): ReactElement => {
  return <GroupDetailContainer />;
};
export default GroupDetail;
